import { Link } from 'react-router';
import { Logo } from '@/components/brand/Logo.tsx';
import { Button } from '@/components/ui/Button.tsx';

export function Landing() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-2xl flex-col justify-center px-6 py-12">
      <Logo className="text-2xl" />
      {/* Brand tagline (§1 brand foundations). "every" is always underlined
          in teal when the tagline appears in a designed context. */}
      <h1 className="mt-8 text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
        Grief happens in{' '}
        <span className="underline decoration-teal decoration-2 underline-offset-4">every</span>{' '}
        workplace.
      </h1>
      <p className="mt-4 text-lg text-muted-foreground">We help you get ready for it.</p>
      <p className="mt-3 max-w-xl text-sm text-muted-foreground">
        besideU pairs an empathic AI companion with human Care Guides. HR provisions the
        organisation; managers get a Maeve-guided first response and touch point plan; employees get
        a private, citation-grounded companion for the weeks that follow a loss.
      </p>
      <div className="mt-10 flex flex-wrap gap-3">
        <Link to="/login">
          <Button variant="primary">Sign in</Button>
        </Link>
        <Link to="/sign-up">
          <Button variant="secondary">Set up a new organisation</Button>
        </Link>
      </div>
    </main>
  );
}
